import faqPageShapesBackgroundCorner from './faq-page-shapes-background-corner.svg';

export default {
  'faq-page-shapes-background-corner': faqPageShapesBackgroundCorner,
};
